import { Grid } from '@mui/material'
import { styled } from '@mui/system'
import Button from '../../../molecules/button'
import Typography from '../../../atoms/typography'
import { PRODUCT_TYPE_GIFTCARD } from '@bluheadless/ui-logic/src/constants'

const shouldForwardProp = (prop) => !['columns', 'type'].includes(prop)

const Root = styled(Grid, { shouldForwardProp })`
	${({ theme }) => theme.breakpoints.up('md')} {
		max-width: ${({ type }) => (type === PRODUCT_TYPE_GIFTCARD ? '100%' : '70%')};
		padding-bottom: 20px;
	}
`
const OptionsWrapper = styled('div', { shouldForwardProp })`
	display: grid;
	grid-template-columns: repeat(1, 100%);
	margin-top: ${({ theme }) => theme.spacing(4)};
	column-gap: ${({ theme }) => theme.spacing(2)};
	row-gap: ${({ theme }) => theme.spacing(4)};

	div[role='group'] {
		display: table;
	}
	${({ theme }) => theme.breakpoints.up('sm')} {
		grid-template-columns: ${({ columns, theme }) =>
			`repeat(${columns}, calc((100% / ${columns}) - ${columns >= 2 ? theme.spacing(1) : '0px'}))`};
	}
	${({ theme }) => theme.breakpoints.up('md')} {
		width: 205px;
	}
`

const QtyLabel = styled(Typography)`
	font-size: ${({ theme }) => theme.typography.pxToRem(12)};
`

const ButtonAvailabilityInStore = styled(Button)`
	margin-top: ${({ theme }) => theme.spacing(2)};
`
export { Root, OptionsWrapper, ButtonAvailabilityInStore, QtyLabel }
